// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2ll80","sendOtp":"AuthorizeToLogin_sendOtp__1Ie1K"};